module.exports = __webpack_public_path__ + "img/PE.0b9c8583.svg";